export enum AuthGrantType {
    PASSWORD = 'password',
    TOKEN = 'token',
    REFRESH_TOKEN = 'refresh_token',
    PIN = 'pin'
}